import { render, staticRenderFns } from "./BRow.vue?vue&type=template&id=ff4681fc&"
import script from "./BRow.vue?vue&type=script&lang=ts&"
export * from "./BRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports